<!-- Toast Messages -->
<p-toast
  data-testid="synchronization-edit-toast"
  position="top-right"
  [baseZIndex]="9999"
  [autoZIndex]="true"
  [showTransformOptions]="'translateX(100%)'"
  [hideTransformOptions]="'translateX(100%)'"
  [showTransitionOptions]="'0.3s ease-in'"
  [hideTransitionOptions]="'0.3s ease-out'"
  [preventDuplicates]="false"
></p-toast>

@if (loading()) {
<div class="flex items-center justify-center h-64">
  <div class="flex flex-col items-center gap-2">
    <div
      data-testid="synchronization-edit-loading"
      class="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-400"
    ></div>
    <div class="text-gray-600 text-sm">Loading synchronization data...</div>
  </div>
</div>
} @else {
<app-synchronization-form
  data-testid="synchronization-edit-form-wrapper"
  #formWrapper
  [config]="config"
  [editMode]="true"
  [viewMode]="false"
  [initialData]="synchronizationData()"
></app-synchronization-form>
} 
